import { Profile } from '../types/Profile';

export const NameHelper = () => {
  const getFormattedFullName = (profile: Profile): string => {
    return `${profile.profession} ${profile.titleAcademicPre} ${profile.firstname} ${profile.lastname} ${profile.titleAcademicPost}`;
  };
  const getFormattedName = (profile: Profile): string => {
    return `${profile.titleAcademicPre} ${profile.firstname} ${profile.lastname} ${profile.titleAcademicPost}`;
  };

  const getProfessionName = (profile: Profile): string => {
    return `${profile.profession} ${profile.firstname} ${profile.lastname}`;
  };

  return { getFormattedName, getFormattedFullName, getProfessionName };
};
